import { Pills, PillType } from '@agilox/ui-common';
import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { IconModule } from '../icon/icon.module';

@Component({
	selector: 'ui-pill',
	templateUrl: './pill.component.html',
	imports: [NgClass, IconModule],
})
export class PillComponent {
	value = input<string | undefined>();
	type = input<PillType>(Pills.SecondaryFilled);
	disabled = input<boolean>();
	icon = input<string | undefined>();

	classes = computed(() => {
		const baseClasses: { [key: string]: string } = {
			errorFilled: 'bg-error border-error text-white dark:text-secondary-800',
			secondaryFilled: 'bg-secondary-800 border-secondary-800 text-white',
			secondaryLightFilled: 'bg-secondary-200 border-secondary-200 text-secondary-800',
			secondaryOutline: 'bg-transparent border-secondary-800 text-secondary-800',
			successFilled: 'bg-success border-success text-white dark:text-secondary-800',
		};

		const disabledClasses: { [key: string]: string } = {
			errorFilled: 'bg-transparent border-secondary-400 text-secondary-400',
			secondaryFilled: 'bg-transparent border-secondary-400 text-secondary-400',
			secondaryLightFilled: 'bg-transparent border-secondary-400 text-secondary-400',
			secondaryOutline: 'border-secondary-400 text-secondary-400',
			successFilled: 'bg-transparent border-secondary-400 text-secondary-400',
		};

		if (this.disabled()) {
			return disabledClasses[this.type()] || '';
		}
		return baseClasses[this.type()] || '';
	});
}
